class Setters {
  constructor (Ramda) {
    const R = Ramda

    const importGlobal = R.curry((object, key, cookies) => {
      if (!object[key]) {
        return JSON.parse(cookies.get('currentUser'))[key]
      } else {
        return object[key]
      }
    })

    const setTagName = R.curry((lib, activity) => {
      switch (true) {
        case lib.isPositionByDelegationType(activity):
          return 'Cargos por delegación'
        case lib.isRolesType(activity):
          return 'Roles'
        case lib.isCommitteeParticipationType(activity):
          return 'Participación en comites'
        case lib.isOtherActivitiesType(activity):
          return 'Otras Actividades'
        case lib.isSubjectType(activity):
          return 'Asignatura'
        case lib.isStudentAttentionType(activity):
          return 'Atención Estudiantes'
        case lib.isActivitiesType(activity):
          return 'Actividad'
        case lib.isDoctoralEducationType(activity):
          return 'Formación Doctoral'
        case lib.isTeacherDevelopmentType(activity):
          return 'Desarrollo Profesoral'
        case lib.isCommunityType(activity):
          return 'Comunidades de aprendizaje y práctica'
        case lib.isProjectDesignType(activity):
          return 'Formulación de proyectos'
        case lib.isProjectsType(activity):
          return 'Proyectos'
        case lib.isProductsType(activity):
          return 'Productos'
        case lib.isColaborationSpaceType(activity):
          return 'Espacios de colaboración'
        case lib.isResultsTransferType(activity):
          return 'Transferencia de resultados'
        case lib.isInvestigationType(activity):
          return 'Formación en Investigación'
        case lib.isInternalProjectsFormulationType(activity):
          return 'Formulación de proyectos internos'
        case lib.isExtensionProjectsType(activity):
          return 'Proyectos internos'
        case lib.isVisibilityType(activity):
          return 'Visibilidad'
        case lib.isConsultancyType(activity):
          return 'Asesoría/Consultoría'
        case lib.isShortCoursesType(activity):
          return 'Cursos cortos'
        case lib.isCrossProjectFormulationType(activity):
          return 'Formulación de proyectos transversal'
        case lib.isCrossExtensionProjectsType(activity):
          return 'Proyecto transversal'
      }
    })

    const formatActivity = R.curry((setTagName, activities, stageId) => {
      return activities.map((activity) => {
        activity.periodicityName = activity.periodicityName ? activity.periodicityName.split(',').join(', ') : null
        activity.tagName = setTagName(activity)
        activity.stageId = stageId
        return activity
      })
    })

    const flatten = arr => {
      return arr.reduce((acc, val) => {
        return acc.concat(Array.isArray(val) ? flatten(val) : val)
      }, [])
    }

    const sortById = list => {
      let sorted = []
      let ids = []
      list.forEach((obj) => {
        if (!ids.filter(x => x === obj.activityTypeId).length) {
          ids.push(obj.activityTypeId)
        }
      })
      ids = ids.sort((x, y) => {
        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
      ids.forEach(id => {
        sorted.push(sortByName(list.filter(x => x.activityTypeId === id), id))
      })
      return flatten(sorted)
    }

    const sortByName = (list, id) => {
      let keyName = [
        'name',
        'asignatureName',
        'itemName',
        'nameCharge',
        'workplanTeacherChargeName',
        'otherActivityItemName',
        'scheduleTypeName',
        'committeeName',
        'roleName' ].filter(name => {
          return Reflect.has(list[0], name) && Boolean(list[0][name])
        }).filter(Boolean).slice(0, 1)
      return list
        .sort((a, b) => {
          if (a[keyName] < b[keyName]) return -1
          if (a[keyName] > b[keyName]) return 1
          return 0
        })
    }

    const sortActivitiesList = sortById

  // VALIDATIONS SIGNATURE
    return {
      importGlobal: importGlobal,
      setTagName: setTagName,
      formatActivity: formatActivity,
      sortActivitiesList: sortActivitiesList,
      sortById: sortById,
      sortByName: sortByName
    }
  }
}

Setters.$inject = ['Ramda']
export default angular.module('services.Setters', []).service('Setters', Setters).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/lib/setters.js